<template>
  <div class="player container">
    <div class="player-container">
      <video id="player" class="video-js vjs-default-skin" controls preload="none">
        <source :src="this.statis.url"
          type="application/x-mpegURL" />
      </video>
    </div>
    <div class="player-statistics">
      <div class="statis-item item-offload">
        <span class="item-label">
          <span class="item-label-data">{{statis.offload}}</span> MB<br />
          <span class="item-name offload">Offload</span>
        </span>
      </div>
      <div class="statis-item item-ratio">
        <span class="item-label">
          <span class="item-label-data">{{statis.ratio}}</span> %<br />
          <span class="item-name ratio">P2P Ratio</span>
        </span>
      </div>

      <div class="statis-item item-upload">
        <span class="item-label">
          <span class="item-label-data">{{statis.upload}}</span> MB<br />
          <span class="item-name upload">Upload</span>
        </span>
      </div>

      <div class="statis-item item-rebuffers">
        <span class="item-label">
          <span class="item-label-data">{{statis.buffers}}</span><br />
          <span class="item-name rebuffers">Rebuffers</span>
        </span>
      </div>

      <div class="statis-item item-peers">
        <span class="item-label">
          <span class="item-label-data">{{statis.peers}}</span><br />
          <span class="item-name peers">Peers</span>
        </span>
      </div>

<!--      <div class="statis-item item-peerid">-->
<!--        <span class="item-label">-->
<!--          <span class="item-label-data">{{p2pVersion}}</span><br />-->
<!--          <span class="item-name peerid">Version</span>-->
<!--        </span>-->
<!--      </div>-->

      <div class="statis-item item-peerid">
        <span class="item-label">
          <span class="item-label-data" style="font-size: 18px">{{statis.connected ? 'Connected' : 'Connecting'}}</span><br />
          <span class="item-name peerid">Server</span>
        </span>
      </div>

    </div>
    <div class="clear"></div>

    <div class="player-url">
      <div class="player-input">
        <input type="url" :placeholder="this.statis.url" v-on:change="inputChange"/>
        <div class="player-play">
          <a class="button" @click="playVideo">Play</a>
        </div>
      </div>
      <div class="simulate">
        <a class="button" @click="simulate">Simulate Peer</a>
      </div>
    </div>
    <div v-if="!isMobile">
      <h4>The graphs on the bottom represent video segments, showing how much content is delivered via the CDN and how much one tab is downloading from the others.</h4>
    </div>
  </div>
</template>

<script>
// import P2pEngineHls from 'swarmcloud-hls/dist/p2p-engine.min';
import { isMobile } from "@/utils/tools";
export default {
  name: 'HLS-Player',
  props: {
    playerData: {
      type: Object,
      required: true,
      default() {
        return {
          url: '',
          offload: '0',
          ratio: '0',
          upload: '0',
          peers: '0',
          buffers: 0,
          peerID: '',
        }
      }
    },
  },
  data() {
    return {
      statis: {
        url: '',
        offload: '0',
        upload: '0',
        ratio: '0',
        peers: '0',
        buffers: 0,
        peerID: '',
      },
      p2pVersion: '',
      isMobile: false,
      serverConnected: false,
    }
  },
  watch: {
    playerData: {
      handler(val) {
        this.statis = JSON.parse(JSON.stringify(val))
      },
      immediate:true,
      deep: true
    }
  },
  mounted() {
    this.p2pVersion = P2PEngineHls.version;
    this.isMobile = isMobile();
    const setupListener =  (engine) => {
      engine.on('stats', this.$parent.onStats);
      engine.on('peerId', this.$parent.onPeerID);
      engine.on('peers', this.$parent.onPeers);
      engine.on('FRAG_LOADED', this.$parent.onFogLoaded)
      engine.on('serverConnected', this.$parent.onServerConnected)
    }
    var p2pConfig = {
      // trackerZone: 'hk',
      // announce: "https://gz.web3-lab.com:2096/v1",    // TODO
      logLevel: 'debug',
      trickleICE: true,
      token: 'WP9fJYo4g',
      // superPeer: true,
      // segmentId: function (level, sn, url, range) {
      //     return `${level}-${sn}`
      // },
    };
    var options = {
      autoplay: true,
      html5: {
        hlsjsConfig: {
          // Put your hls.js config here
          // debug: true,
          maxBufferSize: 0,
          maxBufferLength: 10,
          liveSyncDurationCount: 10,
        }
      }
    };
    if (videojs.Html5Hlsjs) {
      videojs.Html5Hlsjs.addHook('beforeinitialize', (videojsPlayer, hlsjsInstance) => {
        if (P2PEngineHls.isSupported()) {
          var engine = new P2PEngineHls({
            hlsjsInstance,
            ...p2pConfig
          });
        }
        hlsjsInstance.on(Hls.Events.ERROR, this.$parent.HLSerror);
        setupListener(engine);
      });
    } else {
      const engine  = new P2PEngineHls(p2pConfig);
      setupListener(engine)
    }

    var player = videojs('#player', options);
  },
  methods: {
    simulate() {
      window.open(`${window.location.origin}${window.location.pathname}?url=${encodeURIComponent(this.statis.url)}`)
    },
    playVideo() {
      // videojs("player").src([{ type: "application/x-mpegURL", src: this.statis.url }])
      // videojs("player").play()
      window.open(`${window.location.origin}${window.location.pathname}?url=${encodeURIComponent(this.statis.url)}`, '_self')
    },
    inputChange(e) {
      this.statis.url = e.target.value
    }
  }
}
</script>

<style>
  .player-url {
    margin-top: 50px;
    width: 100%;
    height: 40px;
  }
  .player-input {
    width: 80%;
    height: 100%;
    float: left;
  }
  .player-input input {
    width: 84%;
    height: 40px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-sizing: border-box;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .simulate {
    float: right;
    width: 15%;
    height: 100%;
  }
  .player-play {
    width: 15%;
    height: 100%;
    display: inline-block;
  }
  .player-play a {
    width: 100%;
    padding: 6px 12px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .player {
    height: 490px;
    margin-top: 50px !important;
    font-family: "AltGotNo3D", "Source Sans Pro", sans-serif;
  }
  .player-container {
    float: left;
    width: 64%;
  }
  #player {
    width: 100%;
    height: 400px;
  }
  .player-statistics {
    float: right;
    width: 30%;
    height: 400px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .clear {
    clear: both;
  }
  .statis-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .item-label {
    position: absolute;
    top: 35%;
    left: 0.4rem;
    right: 0.4rem;
    text-align: center;
    line-height: 30px;
  }
  .item-label-data {
    font-size: 1.5rem;
    font-weight: 600;
    color: rgb(10, 55, 88);
    font-family: "AltGotNo3D", "Source Sans Pro", sans-serif !important;
  }
  .item-name {
    line-height: 24px;
    font-size: .875rem !important;
    font-weight: 500 !important;
    color: #fff !important;
    padding: 2px 5px;
    border-radius: 5px;
  }

  .item-offload {
    border: 0.05em solid #5cb85c;
  }
  .item-ratio {
    border: 0.05em solid #3c8105;
  }
  .item-peers {
    border: 0.05em solid #5bc0de;
  }
  .item-rebuffers {
    border: 0.05em solid #d9534f;
  }
  .item-upload {
    border: 0.05em solid #337ab7;
  }
  .item-peerid {
    border: 0.05em solid #f0ad4e;
  }
  /*.item-peerid .item-label {*/
    /*line-height: 16px !important;*/
  /*}*/
  /*.item-peerid span {*/
    /*font-size: 0.85rem !important;*/
    /*word-wrap: break-word !important;*/
  /*}*/

  .offload {
    background-color: #5cb85c;
  }
  .ratio {
    background-color: #3c8105;
  }
  .peers {
    background-color: #5bc0de
  }
  .rebuffers {
    background-color: #d9534f
  }
  .peerid {
    background-color: #d9534f
  }
  .upload {
    background-color: #337ab7;
  }
  .peerid {
    background-color: #f0ad4e;
  }



</style>
